import { render, staticRenderFns } from "./ProductFamily.vue?vue&type=template&id=da25dff8&"
import script from "./ProductFamily.vue?vue&type=script&lang=js&"
export * from "./ProductFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports